// src/components/admin/AdminPanel.jsx
import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import Dashboard from './Dashboard';
import Products from './Products';
import AddProduct from './AddProduct';
import EditProduct from './EditProduct';
import Orders from './Orders';
import Customers from './Customers';
import Support from './Support';
import Storefront from './Storefront';
import StoreSettings from './StoreSettings';
import Payments from './Payments';
import SettingsLayout from './settings/SettingsLayout';
import ColorsSettings from './settings/ColorsSettings';
import HeroSliderSettings from './settings/HeroSliderSettings';
import NavbarSettings from './settings/NavbarSettings';
import EverydayWardrobeSettings from './settings/EverydayWardrobeSettings';
import AboutPageSettings from './settings/AboutPageSettings';
import CategoriesSettings from './settings/CategoriesSettings';
import ContactPageSettings from './settings/ContactPageSettings';
import ContactInfoSettings from './settings/ContactInfoSettings';
import FooterSettings from './settings/FooterSettings';
import PaymentsSettings from './settings/PaymentsSettings';
import './AdminPanel.css';

const AdminPanel = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const adminData = localStorage.getItem('adminData');

    console.log('AdminPanel: Checking authentication');
    console.log('Token exists:', !!token);
    console.log('AdminData exists:', !!adminData);
    console.log('Current path:', location.pathname);

    if (!token || !adminData) {
      console.log('AdminPanel: No token found, redirecting to login');
      // Redirect to login, but preserve the intended destination
      navigate('/admin/login', {
        state: { from: location.pathname },
        replace: true
      });
    } else {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, [navigate, location]);

  // If still loading, show loading spinner
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // If not authenticated, don't render anything (will redirect via useEffect)
  if (!isAuthenticated) {
    return null;
  }

  console.log('AdminPanel: Rendering, current path:', location.pathname);

  return (
    <div className="admin-panel">
      <AdminSidebar />
      <div className="admin-content">
        <Routes>
          {/* Dashboard Routes */}
          <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />

          {/* Product Routes */}
          <Route path="products" element={<Products />} />
          <Route path="add-product" element={<AddProduct />} />
          <Route path="edit-product/:id" element={<EditProduct />} />

          {/* Order Routes */}
          <Route path="orders" element={<Orders />} />
          <Route path="customers" element={<Customers />} />
          <Route path="support" element={<Support />} />
          <Route path="store-front" element={<Storefront />} />
          <Route path="payments" element={<Payments />} />
          <Route path="settings-store" element={<StoreSettings />} />

          {/* Settings Routes */}
          <Route path="settings" element={<SettingsLayout />}>
            <Route index element={<Navigate to="/admin/settings/colors" />} />
            <Route path="colors" element={<ColorsSettings />} />
            <Route path="hero-slider" element={<HeroSliderSettings />} />
            <Route path="navbar" element={<NavbarSettings />} />
            <Route path="everyday-wardrobe" element={<EverydayWardrobeSettings />} />
            <Route path="about-page" element={<AboutPageSettings />} />
            <Route path="categories" element={<CategoriesSettings />} />
            <Route path="contact-page" element={<ContactPageSettings />} />
            <Route path="contact-info" element={<ContactInfoSettings />} />
            <Route path="footer" element={<FooterSettings />} />
            <Route path="payments" element={<PaymentsSettings />} />
          </Route>

          {/* Fallback - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminPanel;